import Auth from './auth'

class Api {

    static getBaseUrl() {
        return 'https://accounts.kodiko.gr/api';
    }

    static send(method, url, data) {

        const baseUrl = this.getBaseUrl();
        const loggedUser = Auth.getLoggedUser();
        const token = (loggedUser) ? loggedUser.token : "";

        return new Promise(function(resolve, reject) {
            let xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function() {
                    if (this.readyState == 4) {
                        const json = (this.responseText) ? JSON.parse(this.responseText) : null;
                        if (this.status == 200 || this.status == 201) {
                            resolve(json);
                        } else {
                            if (this.status == 401) {
                                Auth.deleteLoggedUser();
                                location.reload();
                            }
                            reject(json);
                        }
                    }
                };
                xhttp.open(method, baseUrl + url, true);
                xhttp.setRequestHeader('Bearer-Token', token);
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
                xhttp.setRequestHeader('Accept', 'application/json');
                xhttp.send(JSON.stringify(data));
        });

    }

    static send2(method, url, data, token) {

        const baseUrl = this.getBaseUrl();

        return new Promise(function(resolve, reject) {
            let xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function() {
                    if (this.readyState == 4) {
                        const json = (this.responseText) ? JSON.parse(this.responseText) : null;
                        if (this.status == 200 || this.status == 201) {
                            resolve(json);
                        } else {
                            reject(json);
                        }
                    }
                };
                xhttp.open(method, baseUrl + url, true);
                xhttp.setRequestHeader('Bearer-Token', token);
                xhttp.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
                xhttp.setRequestHeader('Accept', 'application/json');
                xhttp.send(JSON.stringify(data));
        });

    }
}

export default Api